<div class="painel">
  <iframe title="SMG_Painel_Orcamento_v1" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=0df89976-09c1-4328-9c50-a7a224c22610&autoAuth=true&ctid=15dcd909-8dc0-40e9-a1e5-cecb053cdd1a" frameborder="0" allowFullScreen="true"></iframe>
</div>